"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const page_1 = __importDefault(require("@/config/page"));
const routes = buildRoutes(page_1.default);
exports.default = routes;
function buildRoutes(pages, parent = null) {
    const ret = [];
    pages.forEach(v => {
        const item = buildRoute(v, parent);
        if (item)
            ret.push(item);
        if (Array.isArray(v.children)) {
            const subs = buildRoutes(v.children, item);
            subs.forEach(w => {
                var _a;
                const nested = !!((_a = w.meta) === null || _a === void 0 ? void 0 : _a.nested);
                if (item && nested)
                    (item.children || (item.children = [])).push(w);
                else
                    ret.push(w);
            });
        }
    });
    return ret;
    function buildRoute(page, parent) {
        if (!page.router)
            return null;
        const { path } = page;
        const nested = page.router.nested;
        const fullPath = page.router.path;
        const breadcrumb = genBreadcrumb();
        return {
            path: fullPath,
            name: path,
            component: () => Promise.resolve().then(() => __importStar(require(`@/views/pages${path}/index.vue`))),
            props: ({ params = {}, query = {} }) => (Object.assign(Object.assign({}, params), query)),
            meta: { pid: path, breadcrumb, nested }
        };
        function genBreadcrumb() {
            var _a;
            let lastBreadcrumb = (_a = parent === null || parent === void 0 ? void 0 : parent.meta) === null || _a === void 0 ? void 0 : _a.breadcrumb;
            if (!Array.isArray(lastBreadcrumb)) {
                const ret = [];
                let current = page.parent;
                while (current) {
                    const item = { title: current.title, path: current.path, active: !!current.router };
                    ret.push(item);
                    current = current.parent;
                }
                lastBreadcrumb = ret.reverse();
            }
            return [...lastBreadcrumb, { title: page.title, path: fullPath, active: !!page.router }];
        }
    }
}
